module.exports = __webpack_public_path__ + "static/media/Hadyd.d75705fa.jpg";